var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "#0000B8",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0001 0.666687C15.6001 0.666687 0.666748 15.6 0.666748 34C0.666748 52.4 15.6001 67.3334 34.0001 67.3334C52.4001 67.3334 67.3334 52.4 67.3334 34C67.3334 15.6 52.4001 0.666687 34.0001 0.666687ZM30.6667 50.6667V30.6667H37.3334V50.6667H30.6667ZM30.6667 17.3334V24H37.3334V17.3334H30.6667Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b5b652c200ae325cc1ce03987e790616.svg";
export { ForwardRef as ReactComponent };